// Vendor
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

// Components
import AppLink from 'components/AppLink';
import ArticleDescription from 'components/ArticleDescription';
import Heading from 'components/Heading';
import Tags from '../Tags';
import Image from 'components/Image';

import styles from './styles.styl';

const Vendor = ({
  className,
  slug,
  title,
  description,
  image,
  tags,
  pageUrl,
  onChangeCategory,
}) => {
  return (
    <div className={cn(styles.Vendor, className)}>
      <div className={styles.Vendor__logoContainer}>
        <AppLink href={`${pageUrl}/${slug}`} className={styles.Vendor__logo}>
          <Image image={image} />
        </AppLink>
      </div>
      <div className={styles.Vendor__content}>
        <AppLink href={`${pageUrl}/${slug}`} className={styles.Vendor__link}>
          <Heading className={styles.Vendor__name} level={4}>
            {title}
          </Heading>
        </AppLink>

        <ArticleDescription className={styles.Vendor__info} parse>
          {description}
        </ArticleDescription>
        <Tags
          className={styles.Vendor__tags}
          tags={tags}
          url={pageUrl}
          onChangeCategory={onChangeCategory}
        />
      </div>
    </div>
  );
};

Vendor.defaultProps = {
  className: '',
};

Vendor.propTypes = {
  className: PropTypes.string,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired]),
  tags: PropTypes.array,
  pageUrl: PropTypes.string.isRequired,
  onChangeCategory: PropTypes.func,
};

export default Vendor;
